export default __webpack_public_path__ + "static/media/bulb.5e43d4a3.jpeg";